import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from 'axios';
import { toast } from 'react-toastify';
import API from '../../../../../utils';

function OperationsAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ operation_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_operation}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                const operationAnalysis = response.data.data?.operation_analysis || '';
                setCheckedValue({ operation_analysis: operationAnalysis });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch operations analysis error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_operation_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        setCheckedValue({
            operation_analysis: checked ? value : ''
        });

        setUpdatedTask({
            value: checked ? value : ''
        });
    };

    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex'>
                        <div className="">
                            <h5>Operations Analysis</h5>
                        </div>
                        <div>
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.operation_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Enterprise"
                                    checked={checkedValue.operation_analysis === 'Enterprise'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Enterprise</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Leaders are individually accountable for optimizing customer value. Operations enable flexible business strategy and innovative investment.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.operation_analysis === 'Corporation' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Corporation"
                                    checked={checkedValue.operation_analysis === 'Corporation'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Corporation</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • The business is focused on maintaining operations and optimizing costs. The value chain functions are in silos.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.operation_analysis === 'Startup' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Startup"
                                    checked={checkedValue.operation_analysis === 'Startup'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Startup</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Operations is leveraged in core functions.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OperationsAnalysis;
